module.exports = __webpack_public_path__ + "media/1.8cccf6aa.mp3";